<template lang="pug">
div(v-if='data.checkbox')
    el-checkbox(v-model='node.checked', @change='onChangeCamada(data, node)')
    el-tooltip(
        :disabled='camadaNome.length < lengthLegenda ? true : false',
        effect='dark',
        :content='camadaNome',
        placement='top',
        :open-delay='100'
    )
        span(
            @click='node.checked = !node.checked; onChangeCamada(data, node)'
        ) {{ labelName(camadaNome) }}
div(v-else-if='!data.checkbox && data.icon')
    i(:class='data.icon')
    span {{ $t(`mensagens.camadas.pastas.${data.chaveTraducao}`) }}
</template>
<script>

export default {
    name: 'DrawerMenuCamadasTreeItem',
    props: {
        node: {
            type: Object,
            required: true
        },
        data: {
            type: Object,
            required: true
        },
        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {};
    },
    computed: {
        lengthLegenda() {
            return this.menuMaior ? 33 : 16;
        },
        camadaNome() {
            if (this.data.showOnZoom) {
                return this.$t(`mensagens.camadas.${this.data.codigo}`) + ' - (' +
                this.$t('mensagens.camadas.info.visivelEmZoom') + this.data.showOnZoom + ')';
            } else {
                return this.$t(`mensagens.camadas.${this.data.codigo}`);
            }
        }
    },
    methods: {
        onChangeCamada(data, node) {
            this.$emit('onChangeCheckboxCamadas', data, node);
        },
        labelName(node) {
            return node.length < this.lengthLegenda ? node : node.substring(0, this.lengthLegenda) + '...';
        }
    }
};
</script>
